import { useCallback, useEffect, useState } from "react";
import { RegistroOcorrencia } from "../../../services/RegistroOcorrencia";
import { useNavigate, useParams } from "react-router-dom";
import { IRegistroOcorrenciaDTO, IRegistroOcorrenciaForm } from "../../../types/registroOcorrencia";
import { toast } from "react-toastify";
import { Motivo } from "../../../services/Motivo";
import { TipoMotivoEnum } from "../../../enums/motivo";
import { ISelectOptions } from "../../../types/inputs";
import { IArquivoDTO } from "../../../types/arquivo";

export const useImpedimentRegister = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const { uuidAgendamento } = useParams();
    const [registro, setRegistro] = useState<IRegistroOcorrenciaDTO>({} as IRegistroOcorrenciaDTO);
    const [motivosOptions, setMotivosOptions] = useState<ISelectOptions[]>([] as ISelectOptions[]);
    const [files, setFiles] = useState<IArquivoDTO[]>([]);
    const [form, setForm] = useState<IRegistroOcorrenciaForm>({} as IRegistroOcorrenciaForm);

    const getMotivos = useCallback(async () => {
            Motivo.list({ tipo: TipoMotivoEnum.IMPEDIMENTO }).then(({ data }) => {
            const options = data.content.map((i) => ({
                value: i.uuid,
                label: i.descricao,
            }));
            setMotivosOptions(options);
        });
        }, []);

    const getRegistro = useCallback(() => {
        setIsLoading(true);
        RegistroOcorrencia.criar({uuid: uuidAgendamento})
            .then( ({data}) => setRegistro(data))
            .catch( ({response: {data: {mensagem}}}) => toast.error(mensagem) )
            .finally( () => setIsLoading(false) );
    }, []);

    useEffect(() => {
        getRegistro();
        getMotivos();
    }, []);

    function handleFileChange(file: File | null) {
        if (file) {
        setFileLoading(true);
        RegistroOcorrencia.vincularArquivo({ uuid: registro?.uuid, file })
            .then(({ data }) => {
            setFiles(data.arquivos);
            })
            .catch(
            ({
                response: {
                data: { mensagem },
                },
            }) => {
                toast.error(mensagem);
            }
            )
            .finally(() => setFileLoading(false));
        }
    }

    function handleFileRemove(uuidArquivo: string) {
        setFileLoading(true);
        RegistroOcorrencia.desvincularArquivo({ uuidArquivo, uuid: registro?.uuid })
        .then(({ data }) => {
            setFiles(data.arquivos);
        })
        .catch(
            ({
            response: {
                data: { mensagem },
            },
            }) => {
            toast.error(mensagem);
            }
        )
        .finally(() => setFileLoading(false));
    }

    function handleSubmit(data: IRegistroOcorrenciaForm) {
        setIsLoading(true);

        const payload: IRegistroOcorrenciaForm = {
            ...form,
            uuidAgendamento: uuidAgendamento,
        }
        
        RegistroOcorrencia.atualizar({ uuid: registro?.uuid, props: payload })
        .then(() => {
            toast.success("Impedimento registrado com sucesso!");
            setTimeout(() => { navigate(`/meus-agendamentos/agendamento?id=${uuidAgendamento}`); }, 2000);
        })
        .catch(({response: {data: {mensagem}}}) => toast.error(mensagem))
        .finally(() => setIsLoading(false));
    }


    return {
        isLoading,
        registro,
        motivosOptions,
        form,
        setForm,
        files,
        fileLoading,
        handleFileChange,
        handleFileRemove,
        handleSubmit,
    };
}